export default __webpack_public_path__ + "static/media/icon-play.e070b3fe.svg";